import Axios, * as others from 'axios';
import React, { Component,useEffect,useState } from "react";
import URL from '../../Environment';
import './performance.css';

const PerformanceTable = () => {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {

  const fetchData = async () => {
    // try {

      Axios.get(URL + 'api/Performance/GetPerformanceData').then((response) => {
        const res = response.data;
        //console.log(res);
        if (Array.isArray(response.data)) {
          setData(response.data);
        } else {
          //console.error('Response data is not an array', response.data);
          setError('Data is not in the expected array format');
        }
        setLoading(false);   

      }).catch((error) => {
        setError(error);
        setLoading(false); 

      });
  };

  // เรียกใช้งาน fetchData เมื่อค่าตัวแปร count มีการเปลี่ยนแปลง
  fetchData();

  // Cleanup function ที่จะถูกเรียกเมื่อ component ถูก unmount
  return () => {
    // ทำการคืนการทำงานที่ต้องการ (cleanup)
    //console.log('Component unmounted');
  };

  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <table className="table table-bordered table-striped table-condensed table-hover">
      <thead>
        <tr style={{ color: "#ffffff", backgroundColor: "#3f5797" }}>
          <th style={{ textAlign: "center" }}>ปี</th>
          <th style={{ textAlign: "center" }}>สมาชิก (คน)</th>
          <th style={{ textAlign: "center" }}>ทุนเรือนหุ้น (บาท)</th>
          <th style={{ textAlign: "center" }}>กำไรสุทธิ</th>
          <th style={{ textAlign: "center" }}>ปันผล (%)(บาท)</th>
          <th style={{ textAlign: "center" }}>เฉลี่ยคืนเงินกู้</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr key={index}>
            <td style={{ textAlign: "center" }}>{item.year}</td>
            <td style={{ textAlign: "center" }}>{item.participant.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
            <td style={{ textAlign: "center" }}>{item.share.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
            <td style={{ textAlign: "center" }}>{item.net.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
            <td style={{ textAlign: "center" }}>{item.dividend}</td>
            <td style={{ textAlign: "center" }}>{item.refund}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default PerformanceTable;